module.exports = __webpack_public_path__ + "d54aa958aeb0115ca87c9e73b2e82247.svg";